<template>
  <section class="container">
    <div class="row">
      <div class="col-12 text-center my-md-5">
        <h3>
          Votre
          <v-highlight color="pink-500">
            e-mail de parrainage
          </v-highlight>
          a été envoyé !
        </h3>
      </div>
      <div class="col-12 text-center">
        <img
          :src="`${aws}/unicorn-fairy.png`"
          class="img-fluid mb-4"
        >
        <p>
          Votre cagnotte sera créditée de 10 € après la souscription d’un filleul.
        </p>
      </div>
      <div class="col-lg-6 col-12 mx-auto">
        <v-loader
          title="Terminer"
          class="w-100"
          icon="arrow-white-left"
          :next="() => $router.push('/client/perks/sponsorship')"
        />
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'SponsorshipConfirmation',
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
  },
};
</script>
